import {StyleSheet} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize: 11,
    },
    nav: {
        borderBottom: "3px solid gray",
        paddingBottom: "5px",
        marginBottom: 20,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    navImg: {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },
    navImageContainer: {
        width: "100px",
        height: "60px",
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        overflow: "hidden",
    },
    section: {
        marginBottom: 10,
        marginTop: 10,
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    flex: {
        display: "flex",
    },
    flexColumn: {
        display: "flex",
        flexDirection: "column",
    },
    text: {
        fontSize: 11,
        marginBottom: 5,
        paddingBottom: 5,
    },
    headline: {
        fontSize: 14,
        marginBottom: 10,
        fontWeight: 700,
    },
    table: {
        border: "2px solid #dbe6e2",
        borderRadius: "10px",
        padding: "10px",
        marginBottom: "10px",
    },
    titleWithBorder: {
        borderBottom: "2px solid #dbe6e2",
        marginVertical: 5,
        paddingBottom: 5,
    },
    imageRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 10,
        marginBottom: 5,
    },
    imageContainer: {
        width: 200,
        height: 180,
        justifyContent: "center",
        alignItems: "center",
        border: "1px solid #ccc",
        marginBottom: 5,
        display: "flex",
        overflow: "hidden",
    },
    tableImg: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        maxWidth: "100%",
        maxHeight: "100%",
        marginHorizontal: 20,
        fontSize: 10,
        marginTop: 4,
    },
    issueImagesContainer: {
        marginTop: 10,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "column",
        gap: 10,
    },
    noImagesText: {
        paddingVertical: 10,
        fontSize: 10,
        textAlign: "center",
        marginTop: 4,
    },
    navFullWidth: {
        width: "100%",
    },
    navPartialWidth: {
        width: "75%",
    },
    footer: {
        position: "absolute",
        bottom: 30,
        left: 30,
        right: 30,
        height: 40,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        borderTop: "1px solid #dbe6e2",
        paddingTop: 10,
    },
    subscriberLogoContainer: {
        width: 80,
        height: 30,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    subscriberLogo: {
        maxWidth: 80,
        maxHeight: 30,
        objectFit: "contain",
    },

    container: {
        padding: 20,
    },
    title: {
        textAlign: "center",
        fontWeight: "bold",
        fontSize: 20,
        marginBottom: 20,
        textDecorationLine: "underline",
    },
    subtitle: {
        marginTop: 30,
        fontWeight: "bold",
        fontSize: 16,
        textDecorationLine: "underline",
    },

    label: {
        fontWeight: "600",
        marginTop: 10,
    },
    value: {
        marginLeft: 10,
    },
    line: {
        marginLeft: 10,
        marginTop: 5,
    },

});
export default styles;
